import { Link } from "react-router-dom";
import { Mail, Lock, ArrowRight, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
const {login, form, setForm} = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle login logic here
    login();
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-[#fef8f5] flex items-center justify-center py-16 px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg space-y-8">
        <Link
          to="/"
          className="flex gap-x-2 items-center text-[#809080] hover:underline"
        >
          <ArrowLeft className="w-5 h-5" />
          Back
        </Link>

        <div className="text-center">
          <h2 className="text-4xl font-serif font-bold text-[#7a6e5f]">
            Welcome Back
          </h2>
          <p className="mt-2 text-[#7a6e5f] opacity-80">
            Sign in to your <span className="font-medium">SuprSkin</span> account
          </p>
        </div>

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            {/* Email */}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-[#7a6e5f]"
              >
                Email address
              </label>
              <div className="mt-1 relative">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={form.email}
                  onChange={(e) => setForm({...form, email:e.target.value})}
                  className="block w-full px-4 py-3 pl-12 border border-gray-300 rounded-md shadow-sm placeholder-[#cbbdaf] focus:ring-[#809080] focus:outline-none"
                  placeholder="you@example.com"
                />
                <Mail className="absolute left-4 top-3.5 h-5 w-5 text-[#cbbdaf]" />
              </div>
            </div>

            {/* Password */}
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-[#7a6e5f]"
              >
                Password
              </label>
              <div className="mt-1 relative">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={form.password}
                  onChange={(e) => setForm({...form, password:e.target.value})}
                  className="block w-full px-4 py-3 pl-12 border border-gray-300 rounded-md shadow-sm placeholder-[#cbbdaf] focus:ring-[#809080] focus:outline-none"
                  placeholder="••••••••"
                />
                <Lock className="absolute left-4 top-3.5 h-5 w-5 text-[#cbbdaf]" />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between text-sm text-[#7a6e5f]">
            <label className="flex items-center gap-2">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 text-[#809080] rounded border-gray-300"
              />
              Remember me
            </label>

            <Link to="/forgot-password" className="hover:underline">
  Forgot password?
</Link>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#7a6e5f] text-white py-3 rounded-md font-medium hover:bg-[#6a5e53] transition"
          >
            Sign in
          </button>

          {/* Sign up link */}
          <div className="text-center text-sm text-[#7a6e5f]">
            Don’t have an account?{" "}
            <Link
              to="/register"
              className="inline-flex items-center gap-1 font-medium hover:underline"
            >
              Sign up <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-[#ddd]" />
            </div>
            <div className="relative flex justify-center text-sm text-[#a39285] bg-white px-2">
              or continue with
            </div>
          </div>

          {/* Social buttons */}
          <div className="grid grid-cols-2 gap-4">
            <button
              type="button"
              className="w-full flex items-center justify-center gap-2 border border-gray-300 rounded-md py-2 bg-white hover:bg-gray-50 transition"
            >
              <img
                src="https://www.svgrepo.com/show/475656/google-color.svg"
                alt="Google"
                className="w-5 h-5"
              />
              <span className="text-sm text-[#7a6e5f]">Google</span>
            </button>
            <button
              type="button"
              className="w-full flex items-center justify-center gap-2 border border-gray-300 rounded-md py-2 bg-white hover:bg-gray-50 transition"
            >
              <img
                src="https://www.svgrepo.com/show/475647/facebook-color.svg"
                alt="Facebook"
                className="w-5 h-5"
              />
              <span className="text-sm text-[#7a6e5f]">Facebook</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}